<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>用户管理</a-breadcrumb-item>
    <a-breadcrumb-item>注册用户</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row" :gutter="16" align="middle">
      <!-- 日期 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="5" class="tool-title">日期：</a-col>
          <a-col :span="19">
            <a-range-picker style="width: 100%;" v-model:value="dateRange" :format="dateFormat" />
          </a-col>
        </a-row>
      </a-col>

      <!-- UID -->
      <a-col :span="4">
        <a-row>
          <a-col :span="6" class="tool-title">UID：</a-col>
          <a-col :span="18">
            <a-input v-model:value="uid1" style="width: 100%;" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>

      <!-- 是否充值 -->
      <a-col :span="5">
        <a-row>
          <a-col :span="6" class="tool-title">是否充值：</a-col>
          <a-col :span="18">
            <a-select v-model:value="payment" style="width: 100%;" placeholder="请选择">
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="2">否</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>

      <!-- AD识别码 -->
      <a-col :span="5">
        <a-row>
          <a-col :span="7" class="tool-title">AD识别码：</a-col>
          <a-col :span="17">
            <a-input v-model:value="uid2" style="width: 100%;" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>
      <!-- 查询 / 重置按钮 -->
      <a-col :span="4" style="display: flex; justify-content: flex-end; gap: 8px;">
        <a-button type="primary" @click="handleSearch">查询</a-button>
        <a-button @click="handleReset">重置</a-button>
      </a-col>
    </a-row>
  </div>


  <!-- 列表 -->
  <a-table class="table-view" :data-source="dataSource" :columns="columns" :row-key="record => record.id"
    :pagination="pagination" :loading="isLoading" @change="handleTableChange">
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">

      <!-- 广告识别码 -->
      <template v-if="column.key === 'adj_id'">
        {{ record.adj_id || '-' }}
      </template>
      <!-- 充值次数 -->
      <template v-if="column.key === 'order_count'">
        <a class="operation-item" @click="handleDetail(record)">{{ record[column.key] }}</a>
      </template>
      <!--  -->
      <template v-if="column.key === 'total_amount'">
        {{ record.account.total_amount }}
      </template>
      <!-- 剩余虚拟币 -->
      <template v-if="column.key === 'coin'">
        {{ record.account.coin }}
      </template>
      <!-- 剩余赠币 -->
      <template v-if="column.key === 'gift_coin'">
        {{ record.account.gift_coin }}
      </template>
      <!-- 剩余会员天数 -->
      <template v-if="column.key === 'vip_expire_day'">
        {{ getVipTime(record) }}
      </template>
      <!-- 注册时间 -->
      <template v-if="column.key === 'created_at'">
        <a-tooltip>
          <template #title>{{ record.account.created_at ? record.account.created_at.substring(0, 19) : '-'
          }}</template>
          {{ record.account.created_at ? record.account.created_at.substring(0, 10) : '-' }}
        </a-tooltip>
      </template>
      <!-- 上次访问 -->
      <template v-if="column.key === 'last_login_time'">
        <a-tooltip>
          <template #title>{{ record.last_login_time ? record.last_login_time.substring(11, 19) : '-' }}</template>
          {{ record.last_login_time ? record.last_login_time.substring(0, 10) : '-' }}
        </a-tooltip>
      </template>
      <!-- 上次充值 -->
      <template v-if="column.key === 'last_recharge_time'">
        <a-tooltip>
          <template #title>{{ formatRechargeTime(record.account.last_recharge_time, true) }}</template>
          {{ formatRechargeTime(record.account.last_recharge_time) }}
        </a-tooltip>
      </template>

      <!-- 界面语种 -->
      <template v-if="column.key === 'lang_name'">
        {{ record.lang_name || '-' }}
      </template>

      <!-- 最后一次启动的系统 -->
      <template v-if="column.key === 'platform'">
        <span>{{ { 1: 'Android', 2: 'IOS' }[record.platform] || '-' }}</span>
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <a class="operation-item" @click="touchUserDetail(record)">查看</a>
      </template>
    </template>
  </a-table>
  <!-- 用户详情 -->
  <Detail ref="RefDetail" />
</template>

<script setup>
import { Modal } from 'ant-design-vue'
import { onBeforeMount, ref, reactive } from 'vue'
import Pub from '@/utils/public'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import Detail from './components-register/Detail.vue'
import { customerList, customerUserCannel } from '@/api/appfront'
import { registerList } from '@/api/admin'

// 用户详情
let RefDetail = ref(null)
// 加载
let isLoading = ref(false)
// 日期范围
let dateRange = ref([dayjs().subtract(30, 'day'), dayjs()])
// 日期format
const dateFormat = 'YYYY-MM-DD'
// UID
let uid1 = ref(undefined)
let uid2 = ref(undefined)
// 支付方式
let payment = ref(undefined)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: 'UID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '注册时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: 'AD识别码',
    dataIndex: 'adj_id',
    key: 'adj_id'
  },
  {
    title: '充值次数',
    dataIndex: 'order_count',
    key: 'order_count'
  },
  {
    title: '剩余金币',
    dataIndex: 'coin',
    key: 'coin'
  },
  {
    title: '剩余赠币',
    dataIndex: 'gift_coin',
    key: 'gift_coin'
  },
  {
    title: '剩余会员',
    dataIndex: 'vip_expire_day',
    key: 'vip_expire_day'
  },
  {
    title: '上次访问',
    dataIndex: 'last_login_time',
    key: 'last_login_time'
  },
  {
    title: '上次充值',
    dataIndex: 'last_recharge_time',
    key: 'last_recharge_time'
  },
  {
    title: '系统',
    dataIndex: 'platform',
    key: 'platform'
  },
  {
    title: '界面语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '账号信息',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount(() => {
  // 获取注册用户列表
  getCustomerList()
})

// 获取注册用户列表
function getCustomerList() {
  isLoading.value = true
  const params = {
    start_at: dateRange.value ? `${dateRange.value[0].format(dateFormat)}` : undefined,
    end_at: dateRange.value ? `${dateRange.value[1].format(dateFormat)}` : undefined,
    adj_id: uid2.value,
    user_id: uid1.value,
    is_pay: payment.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  registerList(params).then(res => {
    console.log(res);

    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 计算会员到期时间
function getVipTime(record) {
  if (!record.account || !record.account.vip_expire_time) {
    return '0'
  }

  const vipExpireTime = record.account.vip_expire_time

  // 处理特殊时间戳：1970-01-01 表示无过期时间
  if (vipExpireTime === '1970-01-01T00:00:00.000000Z' ||
    vipExpireTime === '1970-01-01 00:00:00' ||
    vipExpireTime.includes('1970-01-01')) {
    return '0'
  }

  try {
    // 解析时间
    const expireDate = new Date(vipExpireTime)
    const now = new Date()

    // 检查日期是否有效
    if (isNaN(expireDate.getTime())) {
      return '0'
    }

    // 如果过期时间小于当前时间，说明已过期
    if (expireDate <= now) {
      return '0'
    }

    // 计算剩余天数
    const millisecond = expireDate.getTime() - now.getTime()
    const day = millisecond / (1000 * 60 * 60 * 24)

    // 检查计算结果是否有效
    if (isNaN(day) || day < 0) {
      return '0'
    }

    // 返回剩余天数（向下取整）
    return Math.floor(day).toString()
  } catch (error) {
    console.error('VIP时间解析错误:', error)
    return '0'
  }
}

// 格式化充值时间
function formatRechargeTime(time, showFullTime = false) {

  if (!time) {
    return '-'
  }

  // 处理特殊时间戳：1970-01-01 表示从未充值
  if (time === '1970-01-01T00:00:00.000000Z') {
    return '-'
  } else {
    // 显示日期（用于表格）
    return time.substring(0, 10)
  }
}

// 分页处理
function handleTableChange(p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getCustomerList()
}

// 查询
function handleSearch() {
  pagination.current = 1
  // 获取列表
  getCustomerList()
}

// 重置
function handleReset() {
  // 筛选项重置
  dateRange.value = null
  uid1.value = undefined
  uid2.value = undefined
  payment.value = undefined
  // 分页重置
  pagination.current = 1
  getCustomerList()
}

// 查看充值详情：新开窗口超链至充值记录页检索该用户
function handleDetail(record) {
  Pub.OPEN_ROUTER('/admin-purchase-record', {
    id: record.id,
    // source: linkSource.value
  })
}

// 查看用户详情
function touchUserDetail(record) {
  RefDetail.value.showDrawer(record)
}
// // 注销
// function touchLogout (record) {
//   Modal.confirm({
//     title: '提示',
//     content: '注销后，清除该用户剩余的虚拟币和会员天数，以及所有的剧集解锁记录!',
//     cancelText: '取 消',
//     okText: '注 销',
//     onOk () {
//       userCannel(record)
//     }
//   })
// }

// 注销用户
function userCannel(record) {
  isLoading.value = true
  const params = {
    user_id: record.id
  }
  customerUserCannel(params).then(res => {
    const { code, data, msg } = res
    if (code === 0) {
      message.success('注销成功')
      getCustomerList()
    } else {
      isLoading.value = false
      message.error(res.message || msg)
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>
/* .table-view {
  margin-top: 30px;
}

 .tool-title {
  font-weight: bold;
}  */
.tool-title {
  line-height: 60px;
  font-weight: 500;
}

.tool-row {
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
